import { Form } from 'antd';
import DirectSaleSummaryOption from './DirectSaleSummaryOption';
import DirectSaleSellerOption from './DirectSaleSellerOption';

export default function DirectSaleSwitch() {
  return (
    <Form.Item noStyle shouldUpdate>
      {({ getFieldValue }) => {
        const reportType = getFieldValue('reportType');

        switch (reportType) {
          case 'sales-summary':
            return <DirectSaleSummaryOption />;
          case 'sales-seller':
            return <DirectSaleSellerOption />;
          default:
            return null;
        }
      }}
    </Form.Item>
  );
}
